import { Column, FieldType } from "../../../../features/ui"
import { CsvImportResult, ImportedCsvReport, ImportPriceField, ProductPricesTemplateColumn } from '../../../../features/importer'
import { isDefined } from "../../../../utils/typeUtils"

interface Props {
    csvImportResult: CsvImportResult
    priceField: ImportPriceField
    onNewUpdate: () => void
}

export const ImportedPricesReport = (props: Props) => {
    const { csvImportResult, priceField, onNewUpdate } = props

    const valueColumns: Column[] = [
        {
            name: ImportPriceField.PURCHASE_PRICE,
            type: FieldType.PRICE,
            label: ProductPricesTemplateColumn[ImportPriceField.PURCHASE_PRICE]
        },
        {
            name: ImportPriceField.PRICE_YIELD,
            type: FieldType.PERCENTAGE,
            label: ProductPricesTemplateColumn[ImportPriceField.PRICE_YIELD]
        },
        {
            name: ImportPriceField.PRICE,
            type: FieldType.PRICE,
            label: ProductPricesTemplateColumn[ImportPriceField.PRICE]
        },
        {
            name: ImportPriceField.PRICE_VAT,
            type: FieldType.PRICE,
            label: ProductPricesTemplateColumn[ImportPriceField.PRICE_VAT]
        }
    ]

    // Solo el campo elegido y los que efectivamente vinieron con valor (un archivo viejo puede traer más de una columna)
    const allRows = [...csvImportResult.importedRows, ...csvImportResult.unimportedRows]
    const usedValueColumns = valueColumns.filter(column =>
        column.name === priceField || allRows.some(row => isDefined(row[column.name]))
    )

    const columns: Column[] = [
        {
            name: 'rowIndex',
            type: FieldType.NUMBER,
            label: 'Fila'
        },
        {
            name: 'product',
            type: FieldType.TEXT,
            label: ProductPricesTemplateColumn.PRODUCT
        },
        ...usedValueColumns
    ]

    return <ImportedCsvReport
        columns={columns}
        csvImportResult={csvImportResult}
        onNewUpdate={onNewUpdate}
    />
}
